"use client"

import { useEffect, useState } from "react"
import { ref as storageRef, listAll, getDownloadURL } from "firebase/storage"
import { storage } from "../Firebase/firebase-config"
import { useGetCurrentUserId } from "../hooks/useGetCurrentUserId"
import { FaDownload, FaExternalLinkAlt } from "react-icons/fa"
import "./Downloads.css"

const Downloads = ({ category, onClose, forcedUserId }) => {
  const { userId: hookUserId, loading: idLoading } = useGetCurrentUserId()
  const effectiveUserId = forcedUserId || hookUserId

  const [files, setFiles] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")

  useEffect(() => {
    const fetchFiles = async () => {
      if (!effectiveUserId || idLoading) return

      setLoading(true)
      setError("")
      setFiles([])

      try {
        const folder = category === "mtc" ? "mtc" : "user-statements"
        const storagePath = `${folder}/${effectiveUserId}`

        const listRef = storageRef(storage, storagePath)
        const listResult = await listAll(listRef)

        const filePromises = listResult.items.map(async (itemRef) => {
          const url = await getDownloadURL(itemRef)
          return { name: itemRef.name, url }
        })

        const fileList = await Promise.all(filePromises)
        setFiles(fileList.reverse())
      } catch (err) {
        console.error("Storage error:", err)
        setError("No files found or access denied.")
      } finally {
        setLoading(false)
      }
    }

    fetchFiles()
  }, [effectiveUserId, category, idLoading])

  const handleDownload = (url, name) => {
    const link = document.createElement("a")
    link.href = url
    link.download = name
    link.rel = "noopener noreferrer"
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const title = category === "mtc" ? "MTC Files" : "Statements"

  return (
    <>
      <div className="file-popup-overlay" onClick={onClose} />

      <div className="file-popup">
        <div className="file-popup-header">
          <h3>{title}</h3>
        </div>

        <div className="file-popup-content">
          {idLoading || loading ? (
            <p className="status-text">Loading files...</p>
          ) : error ? (
            <p className="error-text">{error}</p>
          ) : files.length === 0 ? (
            <p className="status-text">No files available.</p>
          ) : (
            <div className="file-list">
              {files.map((file, idx) => (
                <div key={idx} className="file-row">
                  <div className="file-name" title={file.name}>
                    {file.name}
                  </div>

                  <div className="file-actions">
                    <button
                      className="btn-secondary"
                      onClick={() => window.open(file.url, "_blank")}
                      title="Open in new tab"
                    >
                      <FaExternalLinkAlt />
                    </button>

                    <button
                    
                      onClick={() => handleDownload(file.url, file.name)}
                      title="Download"
                    >
                      <FaDownload />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="file-popup-footer">
          <button className="btn-outline" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </>
  )
}

export default Downloads
